import { queryOptions, type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ItemTypeLevelApi } from '@/common/api/itemTypeLevel';
import type { ItemTypeLevel } from '@/common/api/types/itemType';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { associateById } from '@/common/utils/associateById';

export const itemTypeLevelsQueryOptions = () =>
  queryOptions<ItemTypeLevel[]>({
    queryKey: commonQueryKeys.itemTypeLevels.all,
    queryFn: () => ItemTypeLevelApi.getItemTypeLevels(),
  });

export const useItemTypeLevelsQuery = (options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {}) => {
  return useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
  });
};

export const useItemTypeLevelsByIdQuery = (
  options: Partial<UseQueryOptions<ItemTypeLevel[]>> = {},
) => {
  return useQuery({
    ...itemTypeLevelsQueryOptions(),
    ...options,
    select: associateById,
  });
};
